import { useEffect } from "react";

type PageSeoProps = {
  title: string;
  description: string;
};

export function PageSeo({ title, description }: PageSeoProps) {
  useEffect(() => {
    document.title = title;

    const ensureMeta = (name: string) => {
      let element = document.querySelector(`meta[name=\"${name}\"]`) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
      }
      return element;
    };

    const ensurePropertyMeta = (property: string) => {
      let element = document.querySelector(
        `meta[property=\"${property}\"]`
      ) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", property);
        document.head.appendChild(element);
      }
      return element;
    };

    ensureMeta("description").setAttribute("content", description);
    ensurePropertyMeta("og:title").setAttribute("content", title);
    ensurePropertyMeta("og:description").setAttribute("content", description);
    ensurePropertyMeta("twitter:title").setAttribute("content", title);
    ensurePropertyMeta("twitter:description").setAttribute("content", description);

    const canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;

    if (canonical) {
      canonical.href = canonicalUrl;
    } else {
      const link = document.createElement("link");
      link.rel = "canonical";
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }
  }, [description, title]);

  return null;
}
